export const AREA = [
  {
    area: '华东地区',
    list: [
      {
        city: '杭州（总部）',
        address: '杭州市上城区钱江路 58 号太和广场2-803',
        tel: '400-6990-220'
      },
      {
        city: '上海',
        address: '上海市闵行区宏汇莲花广场A座708室',
        tel: '400-6990-220'
      },
    ]
  },
  {
    area: '华中地区',
    list: [
      {
        city: '武汉',
        address: '武汉市洪山区文化大道555号融创智谷工业项目（一期）C8-3-601室',
        tel: '400-6990-220'
      },
      {
        city: '郑州',
        address: '郑州市二七区升龙世纪花园二区6号楼1单元',
        tel: '400-6990-220'
      }
    ]
  },
  {
    area: '华南地区',
    list: [
      {
        city: '深圳',
        address: '深圳市龙华区龙华街道三联社区富联一区一巷 OTO创客商务中心217',
        tel: '400-6990-220'
      }
    ]
  },
  {
    area: '华北地区',
    list: [
     
      {
        city: '北京',
        address: '北京市亦庄经济技术开发区BDA企业大道57号楼1712',
        tel: '400-6990-220'
      }
    ]
  },
  {
    area: '西北地区',
    list: [
      {
        city: '西安',
        address: '西安市荣民时代公馆1幢2单元22402室',
        tel: '400-6990-220'
      }
    ]
  },
  {
    area: '西南地区',
    list: [
      {
        city: '成都',
        address: '成都市金牛区花照壁西顺街388号紫宸香颂四期5栋1单元510室',
        tel: '400-6990-220'
      }
    ]
  }
]